import type { User } from "~/types"

export const ADMIN_ROLES: readonly string[] = ["ROLE_PE_ADMIN", "ROLE_SUPER", "ROLE_PE_SUPER"]

export const hasAdminRole = (user?: Pick<User, "roles"> | null): boolean =>
  (user?.roles ?? []).some((role) => ADMIN_ROLES.includes(role))
